import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import Loader from "../../components/shared/Loader";
import { getSportbookIframe, RootState, useAppDispatch, useAppSelector } from "@hypexone/uicore";
import { connect } from "react-redux";

const SportsbookIFrame = ({loggedIn,balance,exposure}) => {
  const {  loading } = useAppSelector((state) => state.auth);
  const { sportbookIframe } = useAppSelector((state) => state.catalog);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const getGameUrl = async () => {
    if (loggedIn) {
      dispatch(getSportbookIframe({
        navigate
      }));
    } else {
      navigate(`/`);
    }
  };
  const {langData} = useAppSelector((state) => state.cms);

  useEffect(() => {
    getGameUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-[100%] h-[90vh] ">
      <Header balance={balance} exposure={exposure} loggedIn={loggedIn} />
      {loading ? (
        <Loader />
      ) : (
        <iframe
          src={sportbookIframe}
          title={langData?.['sports_book']}
          allowFullScreen
          className="h-full w-full"
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
        ></iframe>
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
        loggedIn: state.auth.loggedIn,
  };
};



export default connect(mapStateToProps, null)(SportsbookIFrame);
